// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Label for Collapsed Reports Menu - Matches Admin Menu Style */
.reports-menu-item.has-tooltip {
  position: relative;
}

.reports-menu-item .tooltip-text {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 100%;
  top: 45%;
  transform: translateY(-50%) translateX(-10px); /* Start slightly left for slide effect */
  margin-left: 0px;
  padding: 0px 14px; /* Match icon container padding for consistent height */
  min-height: 40px; /* Match icon highlight height (icon + padding) */
  display: flex;
  align-items: center; /* Vertically center text */
  background-color: var(--color-sidebar-bg) !important; /* Orange background matching admin menu */
  color: #ffffff;
  border: none;
  border-radius: 0; /* Square corners like admin menu */
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 600;
  z-index: 10000;
  box-shadow: 0 0px 0px rgba(255, 140, 66, 0.3); /* No shadow for cleaner look */
  transition: all 0.3s ease; /* Smooth slide-in animation */
  pointer-events: none;
}

/* Show label on hover with slide-in effect */
.reports-menu-item.has-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
  transform: translateY(-50%) translateX(0); /* Slide to normal position */
  background-color: #1a2332; /* Keep same color on hover */
  box-shadow: 0 0px 0px rgba(26, 35, 50, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/ReportsMenuTooltip.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,6CAA6C,EAAE,yCAAyC;EACxF,gBAAgB;EAChB,iBAAiB,EAAE,uDAAuD;EAC1E,gBAAgB,EAAE,iDAAiD;EACnE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,oDAAoD,EAAE,0CAA0C;EAChG,cAAc;EACd,YAAY;EACZ,gBAAgB,EAAE,mCAAmC;EACrD,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,6CAA6C,EAAE,+BAA+B;EAC9E,yBAAyB,EAAE,8BAA8B;EACzD,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,UAAU;EACV,yCAAyC,EAAE,6BAA6B;EACxE,yBAAyB,EAAE,6BAA6B;EACxD,2CAA2C;AAC7C","sourcesContent":["/* Custom Label for Collapsed Reports Menu - Matches Admin Menu Style */\n.reports-menu-item.has-tooltip {\n  position: relative;\n}\n\n.reports-menu-item .tooltip-text {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  left: 100%;\n  top: 45%;\n  transform: translateY(-50%) translateX(-10px); /* Start slightly left for slide effect */\n  margin-left: 0px;\n  padding: 0px 14px; /* Match icon container padding for consistent height */\n  min-height: 40px; /* Match icon highlight height (icon + padding) */\n  display: flex;\n  align-items: center; /* Vertically center text */\n  background-color: var(--color-sidebar-bg) !important; /* Orange background matching admin menu */\n  color: #ffffff;\n  border: none;\n  border-radius: 0; /* Square corners like admin menu */\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 600;\n  z-index: 10000;\n  box-shadow: 0 0px 0px rgba(255, 140, 66, 0.3); /* No shadow for cleaner look */\n  transition: all 0.3s ease; /* Smooth slide-in animation */\n  pointer-events: none;\n}\n\n/* Show label on hover with slide-in effect */\n.reports-menu-item.has-tooltip:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(-50%) translateX(0); /* Slide to normal position */\n  background-color: #1a2332; /* Keep same color on hover */\n  box-shadow: 0 0px 0px rgba(26, 35, 50, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
